import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

import { createTranslationSchemaAnyLang } from '../../../../utils';

export const schema = z.object({
  homeScreenWelcomeText: createTranslationSchemaAnyLang('Tekst powitalny jest wymagany.'),
  homeScreenImg: z.string().min(1, 'Obraz wygaszacza jest wymagany.'),
  languages: z.array(z.string()),
  baseLang: z.string(),
  settings: z.object({
    menuSettings: z.object({
      homeScreen: z.array(z.string()).max(10, 'Możesz ustawić max 10 elementów dla tego menu.'),
      slideMenu: z.array(z.string()).optional(),
      welcomeScreen: z.array(z.string()).max(4, 'Możesz ustawić max 4 elementów dla tego menu.'),
    }).optional(),
  }).optional(),
});

export type DeviceSettingsFormEntity = z.infer<typeof schema>;

const FormResolver: Resolver<DeviceSettingsFormEntity> = zodResolver(schema) as never;

export const FormOptions: UseFormProps<DeviceSettingsFormEntity> = {
  mode: 'onSubmit',
  resolver: FormResolver,
};
